/** Reserved business slugs / subdomain labels — cannot be claimed by tenants. */
export const RESERVED_SUBDOMAINS = [
  "www",
  "app",
  "admin",
  "api",
  "staging",
  "support",
  "mail",
  "status",
  "dashboard",
  "platform",
  "static",
  "cdn",
  "assets",
  "auth",
  "login",
  "signup",
  "help",
  "docs",
  "billing",
  "webhook",
  "webhooks",
  "internal",
  "health",
  "ready"
] as const;

export type ReservedSubdomain = (typeof RESERVED_SUBDOMAINS)[number];

export function isReservedSubdomain(slug: string): boolean {
  const normalized = slug.trim().toLowerCase();
  return (RESERVED_SUBDOMAINS as readonly string[]).includes(normalized);
}
